export default __webpack_public_path__ + "static/media/Cookie-policies-tdsa-03.2645e18c.jpg";